import React from 'react';
import theme from './MandatoryIndicator.module.scss';

interface MandatoryIndicatorProps {}

const MandatoryIndicator: React.FC<MandatoryIndicatorProps> = (props) => {
    return <span className={theme.container}>*</span>;
};

export default MandatoryIndicator;
